<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section"><strong class="bold">COLD</strong> <br/><strong class="bold">FOR THE BASTARDS</strong> <br/><strong class="bold">OF PIZZOFALCONE</strong></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cold-for-the-bastards-of-pizzofalcone_00001.vue?da49e418